import { computed, ref } from 'vue';
import { whenever } from '@vueuse/core';
import { user } from 'app/user';
import { userWatchlist } from 'app/userWatchlist';

const loginModalActive = ref(false);
const mode = ref('login');
const customRedirectUrl = ref(undefined);

function showLoginModal() {
    loginModalActive.value = true;
}

function setRedirectUrl(url) {
    customRedirectUrl.value = url;
}

/**
 * @param {'login' | 'register'} newMode
 */
function setMode(newMode) {
    mode.value = newMode;
}

const resetMode = () => setMode('login');
const resetRedirectUrl = () => setRedirectUrl(undefined);

const redirectUrl = computed(() => customRedirectUrl.value ?? window?.location.href ?? '');

// Reset changes made by consumers whenever the modal closes
whenever(() => !loginModalActive.value, () => {
    resetMode();
    resetRedirectUrl();
});

// Watchlist unauthorized functionality: Add job to watchlist during login via state
userWatchlist.events.on('onUnauthorized', (event) => {
    const [{ watchlistObject }] = event.arguments;
    setRedirectUrl(watchlistObject.state);
    showLoginModal();
});

export function useLogin() {
    return {
        showLoginModal,
        loginModalActive,
        isLoggedIn: user.isLoggedIn,
        setRedirectUrl,
        redirectUrl,
        setMode,
        mode,
    };
}
